import styled from "styled-components";
import { HealthHireMenuContainer } from "../health-hire-menu/health-hire-menu-style";

export const ForeignersHealthHireMenuContainer = styled(HealthHireMenuContainer)``;
